var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-box"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatarUrl || _vm.defaultUrl}}),_c('span',{staticClass:"text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }